import { LogType } from "@/constants/app.enums";
import { YearFilter } from "@/models/audit-log";
import { TransactionLogResponseModel } from "@/models/transaction-log";
import { Button, Col, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table/interface";
import { useEffect, useState } from "react";
import { AuditLogApi } from "../../../../../apis/audit.api";
import showNotification from "../../../../common/notification";
import PaginationComponent from "../../../../common/pagination/component/pagination";
import DrawerFilter from "../drawer-filter/drawer-filter";
import TransactionLogComponent from "../transaction-log-component/trans-log-component";
import "./transaction-log.scss";

export function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${month}/${date}/${year}`;
}

const yearList: YearFilter[] = [
  { id: 1, label: "2024", value: "" },
];

function YearFilterList(props: { filters: YearFilter[] }) {
  return (
    <>
      {props.filters.map((button) => (
        <span key={button.id}>
          <Button value={button.value}>{button.label}</Button>
        </span>
      ))}
    </>
  );
}


interface TerminalDetailProps {
  terminalSerialNumber?: string;
}

function TransactionLog(props: TerminalDetailProps) {
  const [logs, setLogs] = useState<TransactionLogResponseModel[]>([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [filterData, setFilterData] = useState<any>({});

  useEffect(() => {
    handleGetTransactionLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, pageSize, pageNumber]);

  const columns: ColumnsType<TransactionLogResponseModel> = [
    {
      title: null,
      render: (record: any) => {
        return <TransactionLogComponent log={record} />;
      },
    },
  ];

  async function handleGetTransactionLogs() {
    try {
      setOpenDrawer(false);
      setIsLoading(true);

      let filterObject = {
        startDate: filterData.dateTimeFilter ? filterData.dateTimeFilter[0].toISOString() : null,
        endDate: filterData.dateTimeFilter ? filterData.dateTimeFilter[1].toISOString() : null,
        transactionId: filterData.transactionId ?? null,
        sender: filterData.sender ?? null,
        receiver: filterData.receiver ?? null,
        logStatus: filterData.statusFilter ??  null,
        terminalSerialNumber: props.terminalSerialNumber ?? null
      };

      const { data } = await AuditLogApi.getTransationLogs(pageNumber, pageSize, filterObject);

      setLogs(data.records ?? []);
      setTotalRecords(data.totalRecords ?? 0);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportTransactionLog = () => {
    showNotification(
      "error",
      "This feature is not implement for Transaction Log yet."
    );
  };

  return (
    <>
      <div className="row-filter">
      <span className="year-filter">
          <YearFilterList filters={yearList} />
        </span>
        <span className="right-filter">
          <i
            className="icon-paper-export"
            onClick={handleExportTransactionLog}
          ></i>
          <i className="icon-filter-3" onClick={() => setOpenDrawer(true)}></i>
          <DrawerFilter
            openDrawer={openDrawer}
            onClose={() => setOpenDrawer(false)}
            filterData={filterData}
            handleFilterData={(data) => setFilterData(data)}
            type={LogType.TransactionLog}
            setPageNumber={(data) => setPageNumber(data)}
          />
        </span>
      </div>
      <Row>
        <Col span={24}>
          <Table
            showHeader={false}
            rowKey={(x) => x.id}
            columns={columns}
            dataSource={logs}
            loading={isLoading}
            className="tab-audlt-log"
            pagination={{
              pageSize: pageSize,
              current: pageNumber,
              style: { display: "none" },
            }}
          />
        </Col>
        <PaginationComponent
          totalRecords={totalRecords}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      </Row>
    </>
  );
}

export default TransactionLog;
